import { DefaultTheme } from 'styled-components'

import { colors } from './colors'
import { sizing } from './sizing'

export const theme: DefaultTheme = {
    breakPoints: {
        sm: '576px',
        md: '768px',
        lg: '992px',
        xl: '1200px',
    },
    font: {
        backgroundColor: colors.CA_Lightest_Gray,
        lightestColor: '#ffffff',
        darkestColor: colors.CA_Black,
        midDarkColor: colors.CA_Dark_Gray,
        midLightColor: '#a1a1a1',
        errorColor: '#df0017',
        warningColor: '#ffa500',
        infoColor: '#8ABFFF',
        linkColor: colors.CA_Blue,
        successColor: colors.CA_Green,
        successColorLight: colors.CA_Light_Green,
        textColor: '#6C757D',
        darkRed: '#a30000',
    },
    chartFont: {
        family: '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        normalWeight: 400,
    },
    darkBackground: "url('../../common/content/images/login_page_background_dark.png')",
    lightBackground: "url('../../common/content/images/login_page_background_light.png')",
    whiteBackground: '#ffffff',
    checkbox: {
        bgColor: colors.CA_Black,
        markColor: '#fff',
        invertedBgColor: '#fff',
        invertedMarkColor: '#000',
        disabledBgColor: '#a1a1a1',
        disabledMarkColor: '#ddd',
    },
    input: {
        borderColor: '#e7e7e7',
    },
    boxShadow: 'rgba(0,0,0,0.1) 0px 5px 15px',
    brandColors: colors,
    sizing: sizing,
    transition: '0.2s ease;',
}
